import { wrapIntoFragment } from '@infl-ts/ui-wrap-into-fragment';
import { DE$ } from '@infl-ts/util-datum';
import { findActivityById, parseChallengePlayerConfig, removeCPSearchParam, setInitialActivity, useChallengePlayer } from '@infl-ts/util-use-challenge-player';
import * as DE from '@nll/datum/lib/DatumEither';
import { constUndefined, constVoid, pipe } from 'fp-ts/function';
import * as Id from 'fp-ts/Identity';
import * as O from 'fp-ts/Option';
import { useEffect } from 'react';
import { useLocation } from 'react-router';
import { useChallengeData } from './queries';

var useActivityChange = function useActivityChange(challenge, prevLocation, startNewActivity, continueActivity) {
  var location = useLocation();
  useEffect(function () {
    if (!challenge) return;
    var prevConfig = pipe(parseChallengePlayerConfig(prevLocation), O.getOrElseW(constUndefined));
    pipe(parseChallengePlayerConfig(location), O.chain(O.fromPredicate(function (config) {
      return !!prevConfig && config.uuid === prevConfig.uuid && config.activity !== prevConfig.activity;
    })), O.chainNullableK(function (config) {
      return config.activity;
    }), O.chain(function (activityId) {
      return activityId === 'new' ? O.some(null) : findActivityById(activityId, challenge.activities);
    }), O.match(constVoid, function (activity) {
      if (activity) return continueActivity(activity);
      removeCPSearchParam('activity');
      startNewActivity(challenge.firstStage);
    }));
  }, [location, challenge]);
};

var ChallengeWrapper = function ChallengeWrapper(_ref) {
  var challengeId = _ref.challengeId,
      closeActivity = _ref.closeActivity,
      selectedActivity = _ref.activity,
      startNewActivity = _ref.startNewActivity,
      continueActivity = _ref.continueActivity,
      prevLocation = _ref.prevLocation,
      children = _ref.children;

  var _useChallengePlayer = useChallengePlayer(),
      _useChallengePlayer$c = _useChallengePlayer.challengePlayerState,
      activity = _useChallengePlayer$c.activity,
      stage = _useChallengePlayer$c.stage;

  return pipe(useChallengeData({
    variables: {
      challengeId: challengeId
    }
  }), Id.chainFirst(function (challengeData) {
    var challenge = pipe(challengeData, DE.map(function (_ref2) {
      var challenge = _ref2.challenge;
      return challenge;
    }), DE$.getSuccessOrElse(null)); // `Id.chainFirst` is executing this callback synchronously, and unconditionally
    // eslint-disable-next-line react-hooks/rules-of-hooks

    useEffect(function () {
      if ((challenge === null || challenge === void 0 ? void 0 : challenge.id) === challengeId && !activity && !stage) {
        setInitialActivity({
          closeActivity: closeActivity,
          startNewActivity: startNewActivity,
          continueActivity: continueActivity,
          challenge: challenge,
          selectedActivity: selectedActivity
        });
      }
    }, [challengeData, challenge]); // eslint-disable-next-line react-hooks/rules-of-hooks

    useActivityChange(challenge, prevLocation, startNewActivity, continueActivity);
  }), children, wrapIntoFragment);
};

export default ChallengeWrapper;